import React, { useState } from 'react';
import { Container, Row, Col, ListGroup, Button, Image, Form, InputGroup } from 'react-bootstrap';
import { BiTrash } from 'react-icons/bi';

// A component for rendering a single cart item
const CartItem = ({ item, onRemove, onUpdateQuantity, onSelectItem }) => {

    return (
        <ListGroup.Item className="mb-2 p-2" style={{ background: 'transparent' }}>
            <Row className="align-items-center">
                {/* Column 1: Checkbox */}
                <Col xs={1} md={1} className="text-center mb-0 mb-md-0">
                    <Form.Check
                        type="checkbox"
                        onChange={() => onSelectItem(item?.id)}
                        id={`checkbox-${item?.id}`}
                    />
                </Col>

                {/* Column 2: Product Image, Name & Price */}
                <Col xs={5} md={2} className="mb-0 mb-md-0">
                    <Row>
                        <Col xs={12} className="text-center text-md-start">
                            <Image
                                src={item?.product?.image ? item?.product?.image : "default_480x320.png"}
                                alt={item?.product?.name}
                                fluid
                                rounded
                                style={{ maxWidth: '100px' }}
                            />
                        </Col>
                    </Row>
                </Col>

                <Col xs={6} md={5} className="mb-0 mb-md-0">
                    <Row>
                        <Col xs={12} className="text-center text-md-start">
                            <p className="text-muted mb-0" style={{ fontSize: 12 }}>{item?.product?.name}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className="text-center text-md-start">
                            <p className="text-muted mb-0" style={{ fontSize: 12 }}>
                                {/* Rp. {item?.product?.starting_price} */}
                                {item?.product?.promo_price ? (
                                    <>
                                        <span style={{ textDecoration: "line-through", fontSize: '12px', fontWeight: "", marginRight: "8px" }}>
                                            Rp {item?.product?.starting_price}
                                        </span>
                                        <span style={{ fontWeight: "", fontSize: '12px' }}>
                                            Rp {item?.product?.promo_price}
                                        </span>
                                    </>
                                ) : (
                                    <span style={{ fontWeight: "bold" }}>
                                        Rp {item?.product?.starting_price}
                                    </span>
                                )}
                            </p>
                        </Col>
                    </Row>
                </Col>

                {/* Column 3: Quantity Controls */}
                <Col
                    xs={8}
                    md={3}
                    className="d-flex justify-content-start align-items-start mb-1 mb-md-0"
                >
                    <InputGroup
                        className="mb-0 mx-auto"
                        style={{ width: 'fit-content' }} // Ensures the InputGroup only takes as much width as needed
                    >
                        <Button
                            variant="outline-secondary"
                            onClick={() => onUpdateQuantity(item?.id, item?.qty - 1)}
                            disabled={item?.qty <= 1}
                        >
                            -
                        </Button>
                        <Form.Control
                            type="number"
                            min="1"
                            value={item?.qty}
                            readOnly
                            className="text-center"
                            style={{
                                maxWidth: '60%',
                                background: 'transparent'
                            }}
                        />
                        <Button
                            variant="outline-secondary"
                            onClick={() => onUpdateQuantity(item.id, item?.qty + 1)}
                        >
                            +
                        </Button>
                    </InputGroup>
                </Col>


                {/* Column 4: Trash Icon */}
                <Col xs={4} md={1} className="text-center">
                    <Button variant="danger" onClick={() => onRemove(item.id)}>
                        <BiTrash size={20} />
                    </Button>
                </Col>
            </Row>
        </ListGroup.Item>

    );
};

export default CartItem;